/**
 * Utilitaire de test pour la génération de documents PDF sans enregistrement en base de données
 * Ce fichier permet de tester les fonctions de génération de reçus et de formulaires d'expédition
 */

import { generateAndUploadReceipt, generateAndUploadShippingForm } from './generateReceipt';

/**
 * Fonction principale pour tester la génération de documents
 * @param {Object} options - Options de test
 * @param {boolean} options.generateReceipt - Générer un reçu
 * @param {boolean} options.generateShippingForm - Générer un formulaire d'expédition
 * @param {Object} options.userData - Données utilisateur personnalisées (facultatif)
 * @returns {Promise<Object>} - URLs des documents générés
 */
export const testDocumentGeneration = async (options = {}) => {
  const {
    generateReceipt = true,
    generateShippingForm = true,
    userData = {}
  } = options;

  // Données utilisateur par défaut pour les tests
  const defaultUserData = {
    transaction_id: `TEST-${Date.now()}`,
    actTitle: 'PASSEPORT BIOMÉTRIQUE',
    amount: 73,
    paymentMethod: 'Test (Pas de paiement réel)',
    userName: 'Utilisateur Test',
    userFirstName: 'Prénom',
    userLastName: 'Nom',
    userEmail: 'test@example.com',
    userPhone: '+33612345678',
    userAddress: '123 Rue de Test',
    userCity: 'Ville Test',
    userZipcode: '75000',
    userCountry: 'France',
    hostName: 'Hébergeant Test'
  };

  // Fusionner les données utilisateur par défaut avec celles fournies
  const testUserData = {
    ...defaultUserData,
    ...userData
  };

  console.log('Génération de documents de test avec les données suivantes:', testUserData);

  const results = {
    receiptUrl: null,
    shippingFormUrl: null
  };

  try {
    // Générer le reçu si demandé
    if (generateReceipt) {
      console.log('Génération du reçu...');
      results.receiptUrl = await generateAndUploadReceipt(testUserData);
      console.log('Reçu généré avec succès:', results.receiptUrl);
    }

    // Générer le formulaire d'expédition si demandé
    if (generateShippingForm) {
      console.log('Génération du formulaire d\'expédition...');
      results.shippingFormUrl = await generateAndUploadShippingForm(testUserData);
      console.log('Formulaire d\'expédition généré avec succès:', results.shippingFormUrl);
    }

    return results;
  } catch (error) {
    console.error('Erreur lors de la génération des documents de test:', error);
    throw error;
  }
};

/**
 * Exemple d'utilisation avec des données personnalisées
 * Décommentez et exécutez cette fonction pour tester
 */
/*
export const runTest = async () => {
  try {
    const results = await testDocumentGeneration({
      generateReceipt: true,
      generateShippingForm: true,
      userData: {
        userFirstName: 'Jean',
        userLastName: 'Dupont',
        hostName: 'Marie Martin'
      }
    });
    
    console.log('Test terminé avec succès!');
    console.log('URLs des documents générés:', results);
    
    // Ouvrir les documents dans le navigateur
    if (results.receiptUrl) window.open(results.receiptUrl, '_blank');
    if (results.shippingFormUrl) window.open(results.shippingFormUrl, '_blank');
    
    return results;
  } catch (error) {
    console.error('Échec du test:', error);
  }
};
*/
